import {Validators} from '@angular/forms';

import {Helper} from '../../app/shared/classes';
import {ComponentTypesEnum} from '../../app/shared/enums/common';
import {BaseControl, SelectControl} from '../../app/shared/classes/controls';

import {
    ReportTableData,
    ReportTableColumn,
    DialogConfigInterface,
    ReportTableConfigInterface
} from '../../app/shared/components';

import {TradingGroupClientTypesEnum} from '../../app/entries/panel/enums';

export const SearchClientTypeSelector = 'searchClientType';
export const SearchClientNameSelector = 'searchClientName';
export const SearchClientEmailSelector = 'searchClientEmail';
export const SearchClientEnrollTypeSelector = 'SearchClientEnrollType';
export const SearchAliasSelector = 'searchAlias';

export const SearchClientFieldMinLengthSelector = 3;

export const SearchClientDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [],
        buttonsDisabled: false,
        buttonsHidden: true
    };
};

export interface SearchClientControlsInterface {
    clientType: SelectControl,
    clientName: BaseControl,
    clientEmail: BaseControl
}

export const SearchClientControls = (): SearchClientControlsInterface => {
    return {
        clientType: new SelectControl({
            name: SearchClientTypeSelector,
            value: null,
            placeholder: 'Client Type',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            disabled: true,
            options: [
                {
                    label: Helper.textsHelper().getTradingGroupClientType(TradingGroupClientTypesEnum.Individual),
                    value: TradingGroupClientTypesEnum.Individual
                },
                {
                    label: Helper.textsHelper().getTradingGroupClientType(TradingGroupClientTypesEnum.Company),
                    value: TradingGroupClientTypesEnum.Company
                }
            ],
            sortIndex: 4,
            floatingLabelNever: true
        }),
        clientName: new BaseControl({
            name: SearchClientNameSelector,
            value: null,
            placeholder: 'Name',
            validators: [Validators.minLength(SearchClientFieldMinLengthSelector)],
            componentType: ComponentTypesEnum.Text,
            sortIndex: 1,
            floatingLabelNever: true
        }),
        clientEmail: new BaseControl({
            name: SearchClientEmailSelector,
            value: null,
            placeholder: 'Email',
            validators: [Validators.email],
            componentType: ComponentTypesEnum.Text,
            sortIndex: 1,
            floatingLabelNever: true
        }),
    };
};

export const SearchClientDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: SearchClientTypeSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: SearchClientNameSelector,
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: SearchClientEmailSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: SearchClientEnrollTypeSelector,
            value: null,
            hidden: true
        }),
        new ReportTableData<string>({
            colId: SearchAliasSelector,
            value: null,
            hidden: true
        })
    ];
};

export const SearchClientDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Type',
                selector: SearchClientTypeSelector
            }),
            new ReportTableColumn({
                label: 'Name',
                selector: SearchClientNameSelector
            }),
            new ReportTableColumn({
                label: 'Email',
                selector: SearchClientEmailSelector
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false,
        disableColumnsOptions: true
    };
};
